<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <div v-if="busyFetching" class="text-center">
      <i class="fa fa-4x fa-spinner fa-pulse"></i>
    </div>
    <div v-else v-for="coll in questionCollection" :key="coll.languageId">
      <div v-for="(question, questionIndex) in coll.questions" :key="questionIndex">
        <b-card no-body class="mb-1">

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button style="text-align: left; padding-left: 20px;" block href="#" v-b-toggle="'accordion' + questionIndex" variant="info">
              {{$t('question')}}: {{questionIndex+1}}
              <b-badge style="float: right;" variant="light" v-if="currentScaleIsRandomLogicTest"><span style="font-weight:bolder;font-size:12px;margin-left:10px;margin-right:10px;">{{question.difficultyLevel}}</span></b-badge>
            </b-button>
          </b-card-header>
          <b-collapse class="collapse"
                      :id="'accordion' + questionIndex"
                      accordion="question-accordion"
                      role="tabpanel">
            <g-fair-module :isDefaultLanguage="coll.isDefaultLanguage"
                           :question="question"
                           :questionIndex="questionIndex"
                           :isPartOfCollection="true"
                           :isRandomLogicTest="currentScaleIsRandomLogicTest"
                           v-on:onDeleteQuestion="onDeleteQuestion"
                           v-on:showImageBank="showImageBank">
            </g-fair-module>
          </b-collapse>
        </b-card>
      </div>
      <b-button ref="addQuestionButton"
                variant="outline-primary"
                style="margin:5px 0px 10px 0px; width: 100%; font-weight: bold;"
                @click.stop="$emit('addQuestion', coll.questions)">
                +
      </b-button>

      <b-form-group>
        <b-button type="submit" class="me-2">{{ $t('save') }}</b-button>
        <b-button type="reset">{{ $t('cancel') }}</b-button>
      </b-form-group>
    </div>

    <image-bank ref="imageBankRef" v-on:onImageSelected="onImageSelected"></image-bank>

  </b-form>
</template>

<style scoped>
.collapse {
  padding: 15px;
}
</style>

<script>
import imageBank from './imagebank'
import GFairModule from './modules/gfairmodule'

export default {
  name: 'question-editor-gfair',
  data() {
    return {
      selectedImage: {}
    }
  },
  components: {
    imageBank,
    GFairModule
  },
  methods: {
    showImageBank: function(image) {
      this.selectedImage = image
      var bank = this.$refs.imageBankRef
      bank.showBank()
    },
    onSubmit: function(evt) {
      evt.preventDefault()
      var data = this.questionCollection[0]

      this.$emit('formSubmitted', data)
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    },
    onDeleteQuestion(index) {
      this.$emit('deleteQuestion', index)
    },
    onImageSelected: function(image) {
      this.selectedImage.imageUrl = image.fullPath
    }
  },
  props: {
    currentScaleIsRandomLogicTest: false,
    questionCollection: [],
    busyFetching: false
  }
}
</script>
